module.exports = __webpack_public_path__ + "img/ClientePreferencial64.519169ce.png";